import { Button } from 'primereact/button';
import { Link, useHistory } from 'react-router-dom';

export const AccessDenied = () => {
  const history = useHistory();

  return (
    <div className="flex align-items-center justify-content-center w-full min-vh-90 py-6 px-3">
      <div className="text-center surface-card border-round-2xl shadow-3 p-5 md:p-6 max-w-30rem w-full">
        <div
          className="inline-flex align-items-center justify-content-center border-circle mb-4"
          style={{
            width: '5rem',
            height: '5rem',
            backgroundColor: 'var(--light-blue-1)',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-primary"
            style={{ width: '2.5rem', height: '2.5rem' }}
            aria-hidden="true"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <p className="text-primary text-6xl font-bold m-0 mb-2 line-height-1">
          403
        </p>
        <h2 className="text-2xl font-bold m-0 mb-3">Access denied</h2>

        <p className="text-600 line-height-3 m-0 mb-2">
          We&apos;re sorry, but you do not have permission to access this page.
          Please use the sidebar to navigate to pages available to you.
        </p>

        <p className="text-600 line-height-3 m-0 mb-4">
          Need help getting started? Visit our{' '}
          <Link
            to="/get-started"
            className="text-primary font-semibold no-underline"
          >
            Quick Start &amp; Help
          </Link>{' '}
          page for guides and onboarding support.
        </p>

        <Button
          label="Go to Get Started"
          icon="pi pi-arrow-right"
          iconPos="right"
          className="mb-4"
          onClick={() => history.push('/get-started')}
        />

        <p className="text-500 text-sm m-0 line-height-3">
          If you believe this is an error, you can{' '}
          <Link
            to="/support"
            className="text-primary font-semibold no-underline"
          >
            create a support ticket
          </Link>{' '}
          for further assistance.
        </p>
      </div>
    </div>
  );
};
